<template>
  <router-link
    to="/profile"
    active-class="bg-main-50 dark:bg-gray-700 bg-opacity-80 rounded-lg"
    role="button"
    class="flex items-center w-full p-3 leading-tight transition-all rounded-lg outline-none text-start hover:bg-main-50 dark:hover:bg-gray-700 hover:bg-opacity-80 hover:text-main-900 dark:hover:text-gray-100 focus:bg-main-50 dark:focus:bg-gray-700 focus:bg-opacity-80 focus:text-main-900 dark:focus:text-gray-100 active:bg-main-50 dark:active:bg-gray-700 active:bg-opacity-80 active:text-main-900 dark:active:text-gray-100"
  >
    <!-- Profile Icon -->
    <div class="grid mr-4 place-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>

    <!-- Profile Text -->
    <p
      class="text-base antialiased font-normal leading-relaxed text-main-900 dark:text-gray-200"
    >
      Profile
    </p>
  </router-link>
</template>

<script>
export default {
  name: "ProfileNavComponent",
};
</script>
<style scoped>
.profile-icon {
  transition: transform 0.3s ease;
}
.profile-icon:hover {
  transform: scale(1.1);
}
</style>
